import CheckboxComponent from 'app/components/Checkbox/Checkbox';
import { useContext } from 'react';
import { ApplicationRequestContext } from '../../ApplicationRequest';
import { InfoItem } from '../../ConsignedStep/ConsignedCard/ConsignedCard.styles';

type TFgtsQueryCheckboxProps = {
  balanceCheckId?: string;
  onEnable?: () => void;
  disabled?: boolean;
};

const FgtsQueryCheckbox = ({
  balanceCheckId,
  disabled,
  onEnable,
}: TFgtsQueryCheckboxProps) => {
  const {
    fgtsQueryBalanceCheckId,
    setFgtsQueryBalanceCheckId,
    setFgtsPeriods,
    setFgtsValidationErrors,
  } = useContext(ApplicationRequestContext);

  if (!balanceCheckId) {
    return null;
  }

  const isChecked = fgtsQueryBalanceCheckId === balanceCheckId;

  const handleFgtsQueryToggle = () => {
    if (isChecked) {
      setFgtsQueryBalanceCheckId(undefined);
      setFgtsPeriods(undefined);
      setFgtsValidationErrors(false);
      return;
    }

    setFgtsQueryBalanceCheckId(balanceCheckId);
    onEnable?.();
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginTop: '1rem',
      }}
    >
      <CheckboxComponent
        checked={isChecked}
        onChange={handleFgtsQueryToggle}
        disabled={disabled}
      />
      <InfoItem>Desejo consultar o saldo do FGTS</InfoItem>
    </div>
  );
};

export default FgtsQueryCheckbox;
